/**
 * @file
 * Attaches the behaviors for the main Menu component.
 */
 !(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.searchToggle = {
    attach(context) {
      const $searchToggle = $('.search-toggle', context);

      // If there are no search elements within the context,
      // none of the code below should execute.
      if (!$searchToggle.length) {
        return;
      }

      // Preserve the behavior.
      const self = this;
      const $toggle = $searchToggle.find('button');
      $toggle
        .on('click', function () {
          self.closeNav();
          self.exposeSearch($(this));
        })
        .on('keypress', function (e) {
          const keyCode = e.keyCode ? e.keyCode : e.which;
          if (keyCode === 13) {
            self.closeNav();
            self.exposeSearch($(this));
          }
        });
    },

    // exposeSearch($toggle) {
    //   const $search = $('.l-header__global-search');
    //   const state = $search.hasClass('expanded');
    //   const $nav = $('.l-header__navigation');
    //
    //   // // Add an overlay element
    //   const $overlay = $('<div class="search-overlay"></div>');
    //   $('.l-header__wrap').append($overlay);
    //
    //   $search
    //     .toggleClass('expanded', !state)
    //     .attr('aria-expanded', !state ? 'true' : 'false')
    //     .find('input[name="keywords"]').focus();
    //
    //   // Show/hide the overlay based on the state of the search element
    //   if(state){
    //     $nav.find('.main-nav__menu-item').toggleClass('no-hover', false);
    //     $overlay.removeClass('active');
    //   } else {
    //     $nav.find('.main-nav__menu-item').toggleClass('no-hover', true);
    //     $overlay.addClass('active');
    //   }
    // },

    exposeSearch($toggle) {
      const $search = $('.l-header__global-search');
      const state = $search.hasClass('expanded');
      const $nav = $('.l-header__navigation');

      // Add a close button to the search form
      const $closeButton = $('<button class="close-search-button" aria-label="Close search"> X </button>');
      $search.prepend($closeButton);

      // // Add an overlay element
      const $overlay = $('<div class="search-overlay"></div>');
      $('.l-header__wrap').append($overlay);

      $search
        .toggleClass('expanded', !state)
        .attr('aria-expanded', !state ? 'true' : 'false')
        .find('input[name="search_result"]').focus();

      // Show/hide the overlay based on the state of the search element
      if(state){
        $nav.find('.main-nav__menu-item').toggleClass('no-hover', false);
        $overlay.removeClass('active');
        $closeButton.remove(); // Remove the close button when the search is closed
      } else {
        $nav.find('.main-nav__menu-item').toggleClass('no-hover', true);
        $overlay.addClass('active');

        // Add a click event listener to the close button to close the search
        $closeButton.on('click', function() {
          Drupal.behaviors.searchToggle.closeSearch();
        });
      }
    },

    closeSearch() {
      const $search = $('.l-header__global-search');
      const $nav = $('.l-header__navigation');

      // Remove the close button from the search form
      $search.find('.close-search-button').remove();

      // Close the search form
      $search.toggleClass('expanded', false)
        .attr('aria-expanded', false);

      // Hide the overlay and reset the menu items
      $('.search-overlay').removeClass('active');
      $nav.find('.main-nav__menu-item').toggleClass('no-hover', false);
    },


    closeNav(){
      const $nav = $('.l-header__navigation');
      const state = $nav.hasClass('expanded');
      if(state){
        $nav
          .toggleClass('expanded', false)
          .attr('aria-expanded', false);
      }

      $nav.find('.expanded').each(function(){
        $(this).toggleClass('expanded', false);
      });

      $nav.find('.main-nav__menu-item').toggleClass('no-hover', true);
    }
  };
})(jQuery, Drupal);
